import { render, staticRenderFns } from "./InfoSidebar.vue?vue&type=template&id=6c54ee62&"
import script from "./InfoSidebar.vue?vue&type=script&lang=js&"
export * from "./InfoSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports